import { AdminFormFieldsNames, TAdminFormValues } from '../helpers/types';
import { IAdminDetailsDTO } from '@/models/users.model';

class AdminProfileDTO implements Partial<IAdminDetailsDTO> {
  first_name;
  last_name;
  email;
  role;
  region_id;

  constructor(values: TAdminFormValues) {
    this.first_name = values[AdminFormFieldsNames.FIRST_NAME];
    this.last_name = values[AdminFormFieldsNames.LAST_NAME];
    this.email = values[AdminFormFieldsNames.EMAIL];
    this.role = values[AdminFormFieldsNames.ROLE];
    this.region_id = values[AdminFormFieldsNames.REGION_ID] ?? null;
  }
}

export default AdminProfileDTO;
